import React from 'react';

const TermsConditions = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            <h1 className="text-3xl font-extrabold text-gray-900">Terms and Condition</h1>
            <p className="mt-4 text-lg text-gray-500 leading-loose">
                2-7 Days Standard <br />
                {/* <span className='text-sm'>Our website address is: <Link to='https://wehatbazar.com' className='text-blue-500'>https://wehatbazar.com</Link></span> <br />
                What personal data we collect and why we collect it */}
            </p>
        </div>
    );
};

export default TermsConditions;